import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Dynatrace according to hostname
const dynatraceMap: Record<string, string> = {
	'eacat3-cl.aoc.cat': 'https://js-cdn.dynatrace.com/jstag/16a48f5d352/bf33243vvs/9a95b5254002e386_complete.js',
	'eacat3-cl-pre.aoc.cat': 'https://js-cdn.dynatrace.com/jstag/16a48f5d352/bf33243vvs/a2e4dd6b8d87cf52_complete.js'
};

const src = dynatraceMap[window.location.hostname];

if (src) {
	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.src = src;
	script.crossOrigin = 'anonymous';
	document.head.appendChild(script);
}

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
	.catch(err => console.error(err));
